<template>
    <div class="contain">
      <!-- 顶部-->
     <head-comp></head-comp>
       <!-- 内容-->
      <div class="art-box" :style="{minHeight:winHeight.height}">
        <div class="art-right">
          <ol class="breadcrumb art-here">
            当前位置：
            <li><router-link to="/index">首页</router-link></li>
            <li @click="jumpList(actList)" v-if="visible != 2"><a href="javascript:;" >{{name}}</a></li>
            <li class="active" v-if="actList">{{actList.name}}</li>
          </ol>
          <div class="art-txt">
            <div class="txt-tit">{{actList.name}}</div>
            <div class="txt-time">[ 发布时间：<span>{{actList.update_time}}</span>　作者：<span>{{actList.uname}}</span>　浏览：<span>{{see}}</span> ]</div>
            <p class="text" v-html="actList.des"></p>
          </div>
        </div>
      </div>
      <!-- 底部-->
      <foot-comp></foot-comp>
      <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
    <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
    </div>
</template>

<script>
import headComp from "../components/headComp";
import footComp from "../components/footComp";
import { getArticle, updateSee } from "../api/api";
import pageLoad from "../pageload/pageload";
export default {
  components: { headComp, footComp, pageLoad },
  data() {
    return {
      actList: {}, //保存文章数据
      visible: 1, //判断是否为隐藏栏目
      name: "",
      winHeight: {
        //监听屏幕高度
        height: ""
      },
      tip: {}, //提示语
      loading: true, //预加载
      tipShow: false //提示框默认状态
    };
  },
  created() {
    this._getArticle(); //获取文章详情
    window.addEventListener("resize", this.getHeight);
    this.getHeight(); //获取屏幕的高度
  },
  computed: {
    see: function() {
      return parseInt(this.actList.see) + 1;
    }
  },
  methods: {
    //获取屏幕的高度
    getHeight() {
      this.winHeight.height =
        document.documentElement.clientHeight - 130 - 120 - 120 + "px";
    },
    //获取文章详情
    _getArticle() {
      let module = {
        sch_id: 1,
        art_id: this.$route.params.aid
      };
      this.loading = true;
      getArticle(module)
        .then(res => {
          if (res.status && res.data && res.data.des.length > 0) {
            this.actList = res.data;
            this.name = res.data.cateinfo.name;
            this.visible = res.data.cateinfo.visible;
            this._updateSee(); // 更新浏览次数
          } else {
            this.loading = false;
            this.tipCtr("暂无数据");
          }
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    },
    // 更新浏览次数
    _updateSee() {
      let module = {
        sch_id: 1,
        art_id: this.$route.params.aid
      };

      updateSee(module)
        .then(res => {
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    jumpList(item) {
      if (item.cateinfo.pid != 0) {
        this.$router.push({ path: "/list/" + item.cateinfo.pid });
      } else {
        this.$router.push({ path: "/list/" + this.$route.params.cid });
      }
    }
  }
};
</script>

<style scoped>
.contain {
  background: url("../assets/imgs/bk.png");
}
/*内容页*/
.art-banner {
  width: 1200px;
  margin: 20px auto 0;
  height: 100px;
  background-size: cover !important;
}
.art-box {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  overflow: hidden;
}
/*右边内容*/
.art-right {
  width: 100%;
}
.art-here {
  background: #ffffff;
  border-radius: 0;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
}
.paging ul li a {
  margin: 0 2px;
}
.txt-tit {
  color: #428bca;
  font-size: 16px;
  font-weight: bold;
  height: 60px;
  width: 100%;
  border-bottom: 1px #ddd solid;
  text-align: center;
  line-height: 60px;
}
.txt-time {
  width: 100%;
  text-align: center;
  line-height: 40px;
  color: #999;
}
.text {
  border: none;
  background: #ffffff;
  line-height: 30px;
  font-family: "微软雅黑";
}
.art-txt {
  background: #ffffff;
  width: 100%;
  padding: 0 20px;
  min-height: 300px;
  border: 1px #ddd solid;
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/view/article.vue